<template>
  <div class="change-phone">
    <el-button  @click.native="toChangePhone" :loading="btnLoading"  style="width:120px;margin-left:10px"> 更换</el-button>
    <!-- <auth-button opt="change_phone"  @click.native="toChangePhone" :loading="btnLoading" label="更换"></auth-button> -->
    <el-dialog
      :visible="dialogVisible"
      size="small"
      @close="closeDialog"
      width="500px"
    >
      <el-form
        label-width="100px"
        :model="formData"
        :rules="rules"
        align="center"
        class="change-phone-form"
        ref="changePhone"
      >
        <el-form-item
          label="当前绑定手机"
          prop="oldPhone"
        >
          <el-input
            readonly
            placeholder="请输入11位正确手机号"
            v-model="formData.oldPhone"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="短信验证码"
          prop="oldPhoneCode"
        >
          <div class="change-phone__verify-code">
            <el-input
              placeholder="请输入验证码"
              v-model="formData.oldPhoneCode"
              class="change-phone__vc-in"
            ></el-input>
            <el-button
              class="change-phone__vc-get"
              @click="sendMsg('oldPhone')"
              v-if="count.oldPhone===60"
              :loading="sendMsgLoading.oldPhone"
            >
              获取验证码
            </el-button>
            <el-button
              class="change-phone__vc-get"
              @click="sendMsg('oldPhone')"
              v-else
              disabled
            >
              {{ count.oldPhone }}s
            </el-button>
          </div>

        </el-form-item>
        <el-form-item label="新的绑定手机" prop="newPhone">
          <el-input
            placeholder="请输入11位正确手机号"
            v-model="formData.newPhone"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="短信验证码"
          prop="newPhoneCode"
        >
          <div class="change-phone__verify-code">
            <el-input
              placeholder="请输入验证码"
              v-model="formData.newPhoneCode"
              class="change-phone__vc-in"
            ></el-input>
            <el-button
              class="change-phone__vc-get"
              @click="sendMsg('newPhone')"
              v-if="count.newPhone===60"
              :loading="sendMsgLoading.newPhone"
            >
              获取验证码
            </el-button>
            <el-button
              class="change-phone__vc-get"
              @click="sendMsg('newPhone')"
              v-else
              disabled
            >
              {{ count.newPhone }}s
            </el-button>
          </div>

        </el-form-item>
        <div>
          <el-button
            type="primary"
            @click="confirm"
            :loading="confirmLoading"
          >
            确认
          </el-button>
          <el-button @click="cancel">取消</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
// eslint-disable-next-line no-unused-vars
import qs from 'qs'
// eslint-disable-next-line no-unused-vars
import { getChangeSmsCode, submitPhone } from '@/api/setting'
export default {
  props: {
    userAccount: {
      type: String,
      required: true
    },
    phone: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      dialogVisible: false,
      formData: {
        userAccount: '',
        oldPhone: '',
        oldPhoneCode: '',
        newPhone: '',
        newPhoneCode: ''
      },
      rules: {
        oldPhone: [
          { validator: this.validatePhone, trigger: 'blur' }
        ],
        newPhone: [
          { validator: this.validatePhone, trigger: 'blur' }
        ],
        oldPhoneCode: [
          { validator: this.validateVerifyCode, trigger: 'blur' }
        ],
        newPhoneCode: [
          { validator: this.validateVerifyCode, trigger: 'blur' }
        ]
      },
      count: {
        oldPhone: 60,
        newPhone: 60
      },
      timer: {
        oldPhone: null,
        newPhone: null
      },
      sendMsgLoading: {
        oldPhone: false,
        newPhone: false
      },
      confirmLoading: false,
      btnLoading: false
    }
  },
  mounted () {
    console.log(this.formData, '111')
    console.log(this.userAccount, '222')
  },
  methods: {
    validatePhone (rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入手机号'))
      } else {
        if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(value))) {
          callback(new Error('请输入11位正确手机号'))
        }
        callback()
      }
    },
    validateVerifyCode (rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入验证码'))
      }
      callback()
    },

    closeDialog () {
      this.dialogVisible = false
      this.resetForm()
    },
    confirm () {
      this.$refs.changePhone.validate((valid) => {
        if (valid) {
          this.confirmLoading = true
          this.formData.userAccount = this.userAccount
          const params = { ...this.formData }
          submitPhone(params).then(data => {
            this.confirmLoading = false
            if (data.error_code === '0') {
              this.$message.success('更换成功')
              this.resetTimer('oldPhone')
              this.resetTimer('newPhone')
              this.closeDialog()
              this.$emit('change', params.newPhone)
            } else {
              this.$message.error(data.error_msg)
            }
          })
        }
      })
    },
    cancel () {
      this.dialogVisible = false
      this.resetForm()
    },
    sendMsg (phoneType) { // old 旧手机号获取验证码 new 新手机号获取验证码
      this.$refs.changePhone.validateField([phoneType], formError => {
        if (!formError) {
          this.sendMsgLoading[phoneType] = true
          const params = {
            phone: this.formData[phoneType]
          }
          getChangeSmsCode(params).then(data => {
            if (+data.error_code === 0) {
              this.countOperation(phoneType)
            } else {
              this.$message.error(data.error_msg)
            }
            this.sendMsgLoading[phoneType] = false
          })
        } else {
          console.log('formError表单填写有误，请核对！')
          return false
        }
      })
    },
    resetForm () {
      this.$refs.changePhone.resetFields()
    },
    countOperation (phoneType) {
      this.timer[phoneType] = setInterval(() => {
        this.count[phoneType] = this.count[phoneType] - 1
        if (this.count[phoneType] === 0) {
          this.resetTimer(phoneType)
        }
      }, 1000)
    },
    resetTimer (phoneType) {
      clearInterval(this.timer[phoneType])
      this.count[phoneType] = 60
    },
    /**
     * 更换手机号
     */
    toChangePhone () {
      this.dialogVisible = true
      this.formData.oldPhone = this.phone
    }
  },
  beforeDestroy () {
    if (this.timer.oldPhone) {
      this.resetTimer('oldPhone')
    }
    if (this.timer.newPhone) {
      this.resetTimer('newPhone')
    }
  }
}
</script>
<style scoped rel="stylesheet/scss" lang="scss">
    .change-phone {
        display: inline-block;
        &__verify-code {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        &__vc-in {
            width: 220px;
        }
        &__vc-get {
            width: 120px;
        }
        & .el-form-item {
            margin-bottom: 25px;
        }
    }

</style>
